import { Box } from '@mui/material';
import PulpyLogo from 'assets/pulpyLogo.png';
import { useNavigate } from 'react-router-dom';
import SignatureButton from './signatureButton';

function Header() {
  const navigate = useNavigate();

  return (
    <header className="App-header">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3">
            <Box className="d-flex" sx={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
              <img src={PulpyLogo} alt="Pulpy Logo" />
              <h4>
                <i>Email</i> Signatures
              </h4>
            </Box>
          </div>
          <div className="col-md-9 text-end">
            <SignatureButton />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
